<div class="c__heading {{data?.link?.url ? 'has-links' : ''}}">
  <sd-banner
    [isComponentLoading]="isLoading"
    [media]="data?.image"
    [imgRatio]="imageRatio.r16_9"
    [hasAltText]="false"
  />
  @if (!isLoading) {
    <div class="c__text">
      <p class="c__title is-text-brand is-bold {{data?.link?.url ? 'is-interactive' : '' }} {{ isLarge ? 'brand--h3' : 'brand--h4' }}">
        {{data?.name}}
      </p>
      @if (data?.link?.url) {
        <sd-link
          [link]="data?.link"
          [brand]="brand"
          (clicked)="onSubCatLinkClick(data?.link)"
          [customClass]="isDevice$ ? 'is-reset is-full-area' : 'is-full-area'"
        >
          <span class="is-visually-hidden">{{data?.link?.linkName}}</span>
        </sd-link>
      }
    </div>
  }
</div>
@if (!isLoading) {
  @if (data?.list?.items || data?.list?.texts || data?.reviews) {
    <ul sd-list-block class="c__list {{isMobile$ ? 'is-s' : 'is-xs'}}">
      @if (data?.reviews) {
        <li>
          <sd-rating
            [brand]="brand"
            [labelTitle]="'product.rating' | translate"
            [labelHidden]="true"
            [readonly]="true"
            [ratings]="data?.reviews"
          />
        </li>
      }
      @if (data?.list?.texts) {
        @for (listItem of data?.list?.texts | slice: 0 : 5; track listItem) {
          <li>
            @if (data?.list?.icon) {
              <sd-icon [brand]="brand" [size]="iconSize.small" [name]="data?.list?.icon" />
            }
            <sd-html [innerClass]="isMobile$ ? 'is-caption' : ''" [html]="listItem" tag="span" />
          </li>
        }
      }
      @if (data?.list?.items) {
        @for (listItem of data?.list?.items | slice: 0 : 5; track listItem) {
          <li>
            @if (listItem.url) {
              <sd-link [link]="listItem" [brand]="brand" (clicked)="onSubCatLinkClick(listItem)">
                @if (data?.list?.icon) {
                  <sd-icon [brand]="brand" [size]="iconSize.small" [name]="data?.list?.icon" />
                }
                <sd-html [innerClass]="isMobile$ ? 'is-caption' : ''" [html]="listItem?.linkName" tag="span" />
              </sd-link>
            }
            @if (!listItem.url) {
              @if (data?.list?.icon) {
                <sd-icon [brand]="brand" [size]="iconSize.small" [name]="data?.list?.icon" />
              }
              <sd-html [innerClass]="isMobile$ ? 'is-caption' : ''" [html]="listItem?.linkName" tag="span" />
            }
          </li>
        }
      }
      @if (data?.link?.url && (data?.list?.items?.length > 5 || data?.list?.texts?.length > 5)) {
        <sd-link
          [link]="data?.link"
          [brand]="brand"
          class="c__read-more"
          [isSecondary]="contentThemesConfig === themesTextEnum.light"
          [isButton]="true"
          [isSmall]="true"
          (clicked)="onSubCatLinkClick(data?.link)"
          customClass="is-read-more"
        >
          {{"actions.readMore" | translate}}
        </sd-link>
      }
    </ul>
  }
}

@if (isLoading) {
  <sd-skeleton
    [center]="isLarge"
    [appearance]="skeletonAppearanceEnum.heading"
    [width]="80"
    [sizeChangeMobile]="false"
    [count]="isLarge ? 0 : 5"
  />
}
